import Button from '@/components/Buttons/Button';
import styled from '@emotion/styled';

export const HeaderButton = styled(Button)<{ color?: 'primary' | 'secondary'; size?: 'small' | 'default' }>`
    color: ${({ theme }) => theme.colors.black[900]};
    font-size: 18px;
    font-weight: 600;
    line-height: 28px;
    letter-spacing: -0.4px;

    gap: 8px;
    height: ${({ size }) => (size === 'small' ? '40px' : '48px')};
    padding: 14px 24px;
    white-space: nowrap;

    ${({ color, theme }) =>
        color === 'secondary' &&
        `
        background-color: ${theme.colors.white};
        color: ${theme.colors.black[800]};
        border-color: ${theme.colors.black[300]};

        :hover {
            border-color: ${theme.colors.black[300]} !important;
        }
  `}
`;
